import { createFileRoute } from "@tanstack/react-router"
import { parsePersonalityAspectId } from "@/entities/personality"
import { ProfilePersonalityPage } from "@/pages/profile/personality"

export const Route = createFileRoute("/_authenticated/profile/personality")({
	component: ProfilePersonalityPageWrapper,
	validateSearch: (search) => ({
		aspect: parsePersonalityAspectId(search.aspect, "archetype"),
	}),
})

function ProfilePersonalityPageWrapper() {
	const { aspect } = Route.useSearch()
	return <ProfilePersonalityPage aspect={aspect} />
}
